import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"height":"auto"} }
const _hoisted_2 = {
  key: 0,
  class: "loading-indicator"
}
const _hoisted_3 = {
  key: 1,
  class: "error-message"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "table-container" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "pagination-controls",
  style: {"margin-top":"15px","text-align":"center"}
}
const _hoisted_8 = { style: {"margin":"0 10px"} }
const _hoisted_9 = {
  key: 0,
  class: "loading-indicator",
  style: {"text-align":"center","padding":"20px"}
}
const _hoisted_10 = {
  key: 1,
  class: "error-message",
  style: {"color":"red","padding":"20px"}
}
const _hoisted_11 = ["innerHTML"]

import { ref, onMounted, h } from "vue";
import { getCallable, makeCallApiParam } from "@/config/env";
import {
  NDataTable,
  NSpace,
  NCheckbox,
  NCard,
  NSelect,
  NButton,
  NIcon,
  NModal,
  NRadio,
  NRadioGroup,
  NInput,
  FormInst,
  FormRules,
  useMessage,
  useNotification,
  useDialog,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import AddPress from "@/views/press/AddPress.vue";
import { Board } from "@/model/board";
import { QueryInfo } from "@/model/common";
import { usePagination } from "@/composables/usePagination";
import { useAuth } from "@/composables/useAuth";
import { useDownload } from "@/composables/useDownload";
import { useActionDialog } from "@/composables/useDialog";
const getBoards = "getBoards";
const getBoardContent = "getBoardContent";

export default /*@__PURE__*/_defineComponent({
  __name: 'Press',
  setup(__props) {

const { loading, isLoggedIn } = useAuth();
const { downloadNormalFile } = useDownload();
const { show: showActionDialog } = useActionDialog();
const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const getCallApiCallable = getCallable("callApi");
const deletePressCallable = getCallable("deleteBoard");
const componentKey = ref(0);
const deleteConfirmMessage = ref<string | null>(null);
const contentMessage = ref<string | null>(null);
const alertMessage = ref<string | null>(null);
const alertType = ref<string | null>(null);
const isDeleteConfirm = ref<boolean>(false);
const deleteConfirmType = ref<string | null>(null);
const isAddPress = ref<boolean>(false);
const isShowContent = ref<boolean>(false);
const isAlert = ref<boolean>(false);
const isDeleting = ref<boolean>(false);
const isContentLoading = ref<boolean>(false);
const contentError = ref<string | null>(null);
const selectedItem = ref<Board | null>(null);

const {
  paginatedItems: pressList,
  listLoading,
  error,
  currentPage,
  hasNextPage,
  goToNextPage: composableGoToNextPage,
  goToPreviousPage: composableGoToPreviousPage,
  refreshData: composableRefreshPresses,
} = usePagination<Board>(
  async (params) =>
    getCallApiCallable(
      makeCallApiParam(getBoards, {
        ...params,
        type: constant.boardType.PRESS,
      })
    ),
  25 // 페이지 크기
);

const registrationRules: FormRules = {
  title: [
    {
      required: true,
      message: "제목을 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ],
  content: [
    {
      required: true,
      message: "내용을 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ],
};

async function wrappedRefreshPresses() {
  loading.value = true; // 전역 로딩 시작
  await composableRefreshPresses();
  loading.value = false; // 전역 로딩 종료
}

const columns = [
  {
    title: "index",
    key: "index",
    resizable: true,
    render(_row: Board, rowIndex: number) {
      return rowIndex + 1;
    },
  },
  {
    title: "제목",
    key: "title",
    resizable: true,
  },
  {
    title: "내용",
    key: "content_drive_id",
    render(row: Board) {
      return h(
        NButton,
        {
          size: "small",
          onClick: () => {
            onShowContent(row);
          },
          bordered: true,
        },
        { default: () => "내용 보기" }
      );
    },
  },
  {
    title: "첨부파일",
    key: "attached_file_drive_id",
    render(row: Board) {
      return h(
        NButton,
        {
          size: "small",
          onClick: () => {
            onFileDonwload(row);
          },
          bordered: true,
        },
        { default: () => "다운로드" }
      );
    },
  },
  {
    title: "작성자",
    key: "author",
    resizable: true,
  },
  {
    title: "작성일",
    key: "createdDate",
    render(row: Board) {
      return common.getDate(row.createdDate);
    },
  },
  {
    title: "삭제",
    sorter: "default",
    render(row: Board) {
      return h(
        NButton,
        {
          size: "small",
          onClick: () => {
            deletePressItem(row);
          },
          bordered: true,
        },
        { default: () => "삭제" }
      );
    },
  },
];

function showAddPress() {
  isAddPress.value = true;
}

async function hideAddPress() {
  selectedItem.value = null;
  isAddPress.value = false;
  await wrappedRefreshPresses();
}

async function onFileDonwload(row: Board) {
  loading.value = true;
  await downloadNormalFile(row.attached_file_drive_id, row.attached_file_name);
  loading.value = false;
}

async function onShowContent(row: Board) {
  isShowContent.value = true;
  contentMessage.value = ""; // 이전 내용 초기화
  contentError.value = null; // 이전 오류 초기화

  if (row.content_drive_id) {
    isContentLoading.value = true;
    try {
      const result = await getCallApiCallable(
        makeCallApiParam(getBoardContent, { id: row.content_drive_id })
      );
      if (common.evalFunctionResult(result)) {
        const content = common.getItemFromFunctionResult(result);
        contentMessage.value = content;
      } else {
        throw new Error(common.getResultError(result) || "홍보 내용 로드 실패");
      }
    } catch (err: any) {
      console.error("홍보 내용 로드 실패 (content_drive_id):", err);
      contentError.value = `외부 URL에서 내용을 불러오는데 실패했습니다. (오류: ${err.message}). HTML 원본 내용을 표시합니다.`;
      contentMessage.value = row.content || "표시할 내용이 없습니다."; // HTML 원본 내용으로 대체
    } finally {
      isContentLoading.value = false;
    }
  } else {
    contentMessage.value = row.content || "표시할 내용이 없습니다.";
    if (!row.content) {
      contentError.value =
        "표시할 내용 URL이 없으며, 저장된 HTML 원본 내용도 없습니다.";
    }
  }
}

function onPositiveClick() {
  isAlert.value = false;
}

async function wrappedGoToNextPage() {
  if (hasNextPage.value) {
    await composableGoToNextPage();
  }
}

async function wrappedGoToPreviousPage() {
  if (currentPage.value > 1) {
    await composableGoToPreviousPage();
  }
}

function deletePressItem(press: Board) {
  showActionDialog({
    title: "확인",
    content: "홍보물을 하시겠습니까?",
    positiveText: "삭제",
    negativeText: "아니요",
    positiveButtonProps: { type: "error", loading: isDeleting.value },
    confirmButtonLoadingText: "삭제 중...",
    onConfirm: async () => {
      try {
        const result = await deletePressCallable({
          boardType: constant.boardType.PRESS,
          SK: press.SK,
        });
        if (common.evalFunctionResult(result)) {
          message.success("홍보물 삭제가 완료되었습니다.");
          await wrappedRefreshPresses();
        } else {
          throw new Error(
            common.getResultError(result) ||
              "홍보물 삭제 중 오류가 발생했습니다."
          );
        }
      } catch (error: any) {
        console.error("홍보물 삭제 API 호출 실패:", error);
        message.error(
          common.getResultError(error) || "홍보물 삭제 중 오류가 발생했습니다."
        );
      }
    },
  });
}
function onContentModalClose() {
  contentMessage.value = "";
  contentError.value = null;
  isContentLoading.value = false;
}

onMounted(() => {
  wrappedRefreshPresses();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "main_div",
      key: componentKey.value
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(NSpace), null, {
          default: _withCtx(() => [
            _createVNode(_unref(NCard), { style: {"margin-top":"20px","margin-left":"80px","border":"0px","min-width":"800px"} }, {
              default: _withCtx(() => [
                _createVNode(_unref(NSpace), {
                  "item-style": "display: flex;",
                  align: "center"
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createElementVNode("div", { style: {"font-size":"20px","width":"150px","font-weight":"bold"} }, " 홍보 관리 ", -1)
                  ])),
                  _: 1
                }),
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "content_delimiter_line" }, null, -1)),
                _withDirectives(_createVNode(Loading, null, null, 512), [
                  [_vShow, _unref(loading)]
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    onClick: showAddPress,
                    class: "action-button"
                  }, " 홍보 등록 "),
                  (_unref(listLoading))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 홍보 목록을 불러오는 중... "))
                    : _createCommentVNode("", true),
                  (_unref(error))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(error)), 1))
                    : _createCommentVNode("", true),
                  (!_unref(listLoading) && !_unref(error))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          (_unref(pressList).length > 0)
                            ? (_openBlock(), _createBlock(_unref(NDataTable), {
                                key: 0,
                                columns: columns,
                                data: _unref(pressList),
                                pagination: false,
                                bordered: true
                              }, null, 8, ["data"]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_6, "등록된 홍보가 없습니다."))
                        ]),
                        (_unref(pressList).length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createVNode(_unref(NButton), {
                                onClick: wrappedGoToPreviousPage,
                                disabled: _unref(currentPage) === 1,
                                style: {"margin-right":"8px"}
                              }, {
                                default: _withCtx(() => _cache[4] || (_cache[4] = [
                                  _createTextVNode(" 이전 페이지 ")
                                ])),
                                _: 1
                              }, 8, ["disabled"]),
                              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(currentPage)) + " 페이지", 1),
                              _createVNode(_unref(NButton), {
                                onClick: wrappedGoToNextPage,
                                disabled: !_unref(hasNextPage)
                              }, {
                                default: _withCtx(() => _cache[5] || (_cache[5] = [
                                  _createTextVNode(" 다음 페이지 ")
                                ])),
                                _: 1
                              }, 8, ["disabled"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(NModal), {
              show: isAlert.value,
              "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((isAlert).value = $event)),
              "mask-closable": false,
              content: alertMessage.value,
              type: alertType.value,
              preset: "dialog",
              title: "Dialog",
              "positive-text": "확인",
              onPositiveClick: onPositiveClick
            }, null, 8, ["show", "content", "type"]),
            _createVNode(_unref(NModal), {
              show: isShowContent.value,
              "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((isShowContent).value = $event)),
              onAfterLeave: onContentModalClose
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NCard), {
                  style: {"width":"800px","max-height":"80vh","overflow-y":"auto"},
                  title: "홍보 내용",
                  bordered: false,
                  size: "huge",
                  role: "dialog",
                  "aria-modal": "true"
                }, {
                  footer: _withCtx(() => [
                    _createVNode(_unref(NButton), {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (isShowContent.value = false))
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode("닫기")
                      ])),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    (isContentLoading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 내용을 불러오는 중... "))
                      : (contentError.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(contentError.value), 1))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            innerHTML: contentMessage.value
                          }, null, 8, _hoisted_11))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["show"])
          ]),
          _: 1
        })
      ])
    ])), [
      [_vShow, isAddPress.value == false]
    ]),
    _withDirectives(_createVNode(AddPress, {
      onHide: hideAddPress,
      isAddPress: isAddPress.value,
      selectedItem: selectedItem.value
    }, null, 8, ["isAddPress", "selectedItem"]), [
      [_vShow, isAddPress.value == true]
    ])
  ], 64))
}
}

})